<template>
	<img
		:src="iconSrc"
		:class="['icon', sizeClass]"
		:alt="name"
		:style="{ color: iconColor }"
		@error="handleError"
	/>
</template>

<script setup>
import {computed} from 'vue'

const props = defineProps({
	name: {type: String, required: true},
	size: {type: String, default: 'md'}, // xs, sm, md, lg, xl
	color: {type: String, default: 'var(--color-text)'}
	})

const sizeClass = computed(() => `icon-${props.size}`)
const iconSrc = computed(() => new URL(`../assets/icons/${props.name}.svg`, import.meta.url).href)
const iconColor = computed(() => props.color)

function handleError() {
	console.warn(`Icon not found: ${props.name}`)
}

</script>

<style scoped>
.icon {
	display: inline-block;
	vertical-align: middle;
}

.icon-xs {
	width: var(--font-size-base);
	height: var(--font-size-base);
}

.icon-sm {
	width: var(--font-size-xl);
	height: var(--font-size-xl);
}

.icon-md {
	width: var(--font-size-2xl);
	height: var(--font-size-2xl);
}

.icon-lg {
	width: var(--font-size-3xl);
	height: var(--font-size-3xl);
}

.icon-xl {
	width: var(--font-size-4xl);
	height: var(--font-size-4xl);
}

.icon-full {
	width: 100%;
	height: 100%;
}
</style>